/** @jsx h */
import { h } from 'preact'
import ExternalLinkIcon from '../icons/ExternalLinkIcon'

const EvidenceFromActivitySection = ({ title, dateStatement, description, url }) =>
  <section class='ModalCard-section'>
    <h3 class='ModalCard-heading'>{title}</h3>
    <p class='ModalCard-para u-marginTop8'>{dateStatement}</p>
    <p class='ModalCard-para u-marginTop8'>{description}</p>
    <p class='ModalCard-para u-marginTop8'>
      {/* TODO: use ExternalLink here */}
      <a
        href={url}
        class='ExternalLink'
        target='_blank'
        rel='noopener noreferrer'
      >
        <em>{url}</em>
        <ExternalLinkIcon />
      </a>
    </p>
  </section>

export default EvidenceFromActivitySection
